import * as defaultImport from "@splunk/react-ui/ComboBox";
export * from "@splunk/react-ui/ComboBox";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
